// export const MQTT_SERVICE = 'mqtt://127.0.0.1:9911' // mqtt服务地址
export const MQTT_SERVICE = 'mqtt://bjx.weishike.org/mqtt'
export const MQTT_MY = 'wss://bjx.weishike.org/mqtt/' // mqtt连接用户名
